export const orderMap = {
    Crown: 1,
    Browband: 2,
    Cheek: 3,
    Noseband: 4,
    Reins: 5
};
export const stepMap = {
    Crown: '/crown',
    Browband: '/browband',
    Cheek: '/cheekpiece',
    Noseband: '/noseband',
    Reins: '/reins'
};
export function getSortOrder(products, step) {
    return products.find(item => {
        return item.sortOrder === step;
    });
}

export function getAttributes(item, attribute) {
    return item.attributeValues.filter(attr => {
        return attr.attributeName === attribute;
    });
}

export function findMatchingProductIds(array, productId) {
    return array.filter(item => {
        return item.productId === productId;
    });
}

export function findMatchingProductFromProductId(productId, array) {
    const match = [];
    array.find(product => {
        return product.products.find(item => {
            return item.productId === productId ? match.push(item) : '';
        });
    });
    return match[0];
}

function groupItemsByKey(items, key, exclude = []) {
    return items.reduce((obj, attribute) => {
        if (exclude.includes(attribute.attributeName)) {
            return obj;
        }

        if (!obj[attribute[key]]) {
            obj[attribute[key]] = [];
        }

        obj[attribute[key]].push(attribute);

        return obj;
    }, {});
}

export function getAttributesGroupedInDisplayOrder(attributes, order = ['Color', 'Style', 'Size'], exclude = []) {
    const grouped = groupItemsByKey(attributes, 'attributeName', exclude);

    if (!order.length) {
        return Object.keys(grouped)
            .sort()
            .map(item => {
                return {
                    label: item,
                    values: grouped[item]
                };
            });
    }

    return order.map(item => {
        return grouped[item]
            ? {
                  label: item,
                  values: grouped[item]
              }
            : {
                  label: item,
                  values: []
              };
    });
}

export function getInitialStateFromAttributeValues(attributes) {
    const grouped = groupItemsByKey(attributes, 'attributeName');

    return Object.keys(grouped).reduce((obj, key) => {
        obj[`${key}Id`] = '';
        obj[`${key}Name`] = '';
        return obj;
    }, {});
}

export function hasMatchingProductId(pieces, id) {
    return pieces.attributeValues.find(value => {
        return value.attributeValueId === id;
    });
}

export function getProductsByAttributeIds(products, ids) {
    return ids[0] === undefined
        ? products
        : products.filter(product => {
              return !!product.productAttributes.find(attribute => {
                  return ids.includes(attribute.attributeValueId);
              });
          });
}

export function findProductWithAttributeIds(products, ids) {
    return products.find(product => {
        return product.productAttributes.every(attribute => ids.includes(attribute.attributeValueId));
    });
}

export function getAttributeIdsFromState(state) {
    return Object.values(state).filter(n => typeof n === 'number');
}

export function getUpdatedAttributes(attributeValues, currentAttributeCombinations, attributeName) {
    return attributeValues.map(a => {
        a.compatible = currentAttributeCombinations.includes(a.attributeValueId) || a.attributeName === attributeName;
        return a;
    });
}
export function unique(arr) {
    return arr.filter((item, index, arr) => arr.indexOf(item) === index);
}

export function getUniqueAttributeCombinations(products) {
    return unique(
        products
            .map(p => p.productAttributes)
            .reduce((arr, pa) => {
                return arr.concat(pa.map(a => a.attributeValueId));
            }, [])
    );
}

export function getStateByAttributes(pieces, currentState, currentAttributeCombinations, selectedAttributeValueId) {
    const state = {...currentState};

    Object.entries(state).forEach(([key]) => {
        if (/Id/.test(key)) {
            let name = state[key.replace(/Id/, 'Name')];
            let value = state[key];

            if (!currentAttributeCombinations.includes(value) || selectedAttributeValueId === undefined) {
                name = '';
                value = '';
            }

            if (value === selectedAttributeValueId) {
                const attribute = pieces.attributeValues.find(
                    attribute => attribute.attributeValueId === selectedAttributeValueId
                );

                name = attribute.attributeValueName;
                value = selectedAttributeValueId;
            }

            state[key] = value;
            state[key.replace(/Id/, 'Name')] = name;
        }
    });

    return state;
}

export function handleCloseApp() {
    let container = document.createElement('div');
    container.append(
        'Are you sure you want to close the Bridle Builder? If you exit now, your selections may not be saved.'
    );
    smartPak.ui.modal(container, {
        title: 'Whoa There!',
        buttons: {
            'Cancel': function (modal) {
                modal.close();
            },
            'Yes, Close': function () {
                location.href = '/';
            }
        }
    });
}

export const sizeGuideInformation = [
    {
        name: 'Crownpiece',
        id: 'crownpiece',
        image: '/images/bridlebuilder/Measurement_Crownpiece.png',
        measureA:
            "Measure from where your browband would sit (the base of your horse's ear), up over the poll, to the opposite ear base.",
        measureB:
            "Measure from the corner of your horse's eye, up over the poll, to the corner of opposite eye. Your horse's measurement should fit somewhere within the range given of shortest to longest hole.",
        pony: {
            lengthA: '13.5"',
            lengthB: '15.5" - 22"'
        },
        cob: {
            lengthA: '14.5"',
            lengthB: '16.5" - 25"'
        },
        full: {
            lengthA: '15.5"',
            lengthB: '17.5" - 28"'
        },
        oversize: {
            lengthA: '16.5"',
            lengthB: '18.5" - 31"'
        }
    },
    {
        name: 'Browband',
        id: 'browband',
        image: '/images/bridlebuilder/Measurement_Browband.png',
        measureA:
            "Find the base of your horse's ear and measure from a little behind it, across the forehead, to the same spot just behind the back of the opposite ear.",
        measureB: '',
        pony: {
            lengthA: '14.5"',
            lengthB: ''
        },
        cob: {
            lengthA: '15.5"',
            lengthB: ''
        },
        full: {
            lengthA: '16.5"',
            lengthB: ''
        },
        oversize: {
            lengthA: '17.5"',
            lengthB: ''
        }
    },
    {
        name: 'Cheek Piece',
        id: 'cheekpiece',
        image: '/images/bridlebuilder/Measurement_Cheekpiece.png',
        measureA: "Measure from the corner of your horse's mouth to the top of the eye.",
        measureB: '',
        pony: {
            lengthA: '7.5"',
            lengthB: ''
        },
        cob: {
            lengthA: '8.5"',
            lengthB: ''
        },
        full: {
            lengthA: '9.5"',
            lengthB: ''
        },
        oversize: {
            lengthA: '9.5"',
            lengthB: ''
        }
    },
    {
        name: 'Noseband',
        id: 'noseband',
        image: '/images/bridlebuilder/Measurement_Noseband.png',
        measureA:
            'Measure the circumference around the nose from approximately 1.5", or 2 fingers width, below your horse\'s cheek bones.',
        measureB: 'Measure from 1.5", or 2 fingers width, below your horse\'s cheek bone up to the top of the eye.',
        pony: {
            lengthA: '20" - 25"',
            lengthB: '6'
        },
        cob: {
            lengthA: '22" - 27"',
            lengthB: '7.75"'
        },
        full: {
            lengthA: '23" - 29"',
            lengthB: '8.75"'
        },
        oversize: {
            lengthA: '25" - 31"',
            lengthB: '9.75"'
        }
    }
];
